
const initInstallationGuide = (sectionEl) => {
  const popupWrapper  = sectionEl.querySelector('.installation-guide__popup-item');
  const overlay       = sectionEl.querySelector('.installation-guide__popup-overlay');
  const popupContent  = sectionEl.querySelector('.installation-guide__popup-content');
  const closeBtn      = sectionEl.querySelector('.installation-guide__popup-close');
  const searchInput   = sectionEl.querySelector('.installation-guide__popup-search');
  const listItems     = sectionEl.querySelectorAll('.installation-guide__popup-list-item');
  const emptyMsg      = sectionEl.querySelector('.installation-guide__popup-empty');
  const popupTriggers = sectionEl.querySelectorAll('.ig-popup-trigger');

  if (!popupWrapper || !popupContent) return;

  const openPopup = () => {
    popupWrapper.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 250);
  };

  const closePopup = () => {
    popupWrapper.classList.remove('is-open');
    document.body.style.overflow = '';
    if (searchInput) {
      searchInput.value = '';
      filterList('');
    }
  };

  const filterList = (query) => {
    const normalised = query.trim().toLowerCase();
    let visibleCount = 0;

    listItems.forEach((item) => {
      const text    = item.textContent.trim().toLowerCase();
      const matches = normalised === '' || text.includes(normalised);
      item.classList.toggle('ig-hidden', !matches);
      if (matches) visibleCount++;
    });

    emptyMsg?.classList.toggle('is-visible', visibleCount === 0 && normalised !== '');
  };

  popupTriggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openPopup();
    });
  });

  closeBtn?.addEventListener('click', closePopup);

  overlay?.addEventListener('click', closePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popupWrapper.classList.contains('is-open')) {
      closePopup();
    }
  });

  searchInput?.addEventListener('input', () => {
    filterList(searchInput.value);
  });

  popupContent.addEventListener('click', (e) => {
    e.stopPropagation();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.installation-guide-page').forEach(initInstallationGuide);
});
